module.exports = __webpack_public_path__ + "static/img/terminal1.e0f93cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/terminal1.png
// module id = vayI
// module chunks = 0